
function ictcart(){
    var selectors = {
        addToCart: '[data-ictcart-add]',
        addToCartForm: '[data-ictcart-form]',
        openBtn: '[data-ictcart-open]',
        closeBtn: '[data-ictcart-close]',
        counter: '[data-ictcart-counter]',
        removeItem: '[data-ictcart-remove]',
        error: '[data-ictcart-error]',
        quantity: '[data-ictcart-quantity]',
        loader: '[data-ictcart-loader]',
        quantityMinus: '[data-ictcart-quantity-minus]',
        quantityPlus: '[data-ictcart-quantity-plus]',
        item: '[data-ictcart-item]'
   };
   var classes = {
       cartOpen: 'ictcart-open'
   };
   var cartUrls = {
    cartAddUrl: "/cart/add",
    cartChangeUrl: "/cart/change"
   };
   var adding = 0;
   var addText = "";

   init();

   function init(){
        if($(selectors.addToCart).length){
            $(selectors.addToCart).off().on('click', function(e){
                addToCart(e, this);
            });
            if(addText.length == 0)
                addText = $(selectors.addToCart).html();
        }
        if($(selectors.openBtn).length){
            $(selectors.openBtn).off().on('click', openCart);
        }
        if($(selectors.closeBtn).length){
            $(selectors.closeBtn).off().on('click', closeCart);
        }
        if($(selectors.removeItem).length){
            $(selectors.removeItem).off().on('click', removeItem);
        }
        if($(selectors.quantity).length){
            $(selectors.quantity).off().on('keyup', updateQuantity);
        }
        if($(selectors.quantityMinus).length){
            $(selectors.quantityMinus).off().on('click', removeQuantity);
        }
        if($(selectors.quantityPlus).length){
            $(selectors.quantityPlus).off().on('click', addQuantity);
        }
   }

   function addToCart(e, btn){
        e.preventDefault();
        if(adding == 0){
            adding = 1;
            showLoader(true);
            addingToCart(btn);
            var form = $(btn).parents(selectors.addToCartForm).get(0);

            fetch(cartUrls.cartAddUrl + '.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: serialize(form)
            }).then(function(response) {
                return response.json();
            }).then(function(json) {
                updateCart(true, btn);
            }).catch(function(error) {
                console.log(error);
                showError();
                adding = 3;
                addingToCart(btn);
            });
        }
   }

   function updateCart(add, btn){
       if($(selectors.counter).length){
            $.getJSON('/cart.js', function(cart) {
                if(cart.item_count == 0)
                    $(selectors.counter).addClass('d-none');
                else
                    $(selectors.counter).removeClass('d-none');
                $(selectors.counter).html(cart.item_count);
            });
       }
        $("#ictcart").load(location.href+" #ictcart > *", function(data){
            init();
            openCart();
            showLoader(false);
            if(add){
                adding = 2;
                addingToCart(btn);
            }
        }, function(data){
            console.log(data);
            showError();
        });
   }

   function openCart(){
       $('body').addClass(classes.cartOpen);
   }

   function closeCart(){
        $('body').removeClass(classes.cartOpen);
   }

   function addingToCart(button){
        var btn = button ? button : $(selectors.addToCart);
        if(adding == 1)
            $(btn).html($(btn).attr('data-ictcart-addingtext'));
        else if(adding == 2){
            $(btn).html($(btn).attr('data-ictcart-addedtext'));
            setTimeout(function(){
                adding = 0;
                addingToCart(btn);
            }, 3000);
        }
        else if(adding == 3){
            $(btn).html($(btn).attr('data-ictcart-error'));
            adding = 0;
        }
        else
            $(btn).html(addText);
   }

   function showError(){
       if($(selectors.error).length)
            $(selectors.error).css('display', 'block');
        showLoader(false);
   }

   function removeItem(){
       var line = $(this).parents(selectors.item).attr('data-ictcart-item');
       showLoader(true);
        $.ajax({
            type: "GET",
            url: '/cart/change?line='+line+'&amp;quantity=0',
            cache: false,
            success: function(data){
               updateCart(false);
            },
            error: function(error){
                console.log(error);
                showError();
            }
        });
   }

   function updateQuantity(){
       var num = parseInt($(this).val());
       if(!isNaN(num) && num > 0){
           showLoader(true);
           var line = $(this).parents(selectors.item).attr('data-ictcart-item');
           $.ajax({
                type: "GET",
                url: '/cart/change?line='+line+'&amp;quantity='+num,
                cache: false,
                success: function(data){
                    updateCart(false);
                },
                error: function(error){
                    console.log(error);
                    showError();
                }
            });
       }
   }

   function removeQuantity(){
       var input = $(this).parents(selectors.item).find(selectors.quantity);
       var num = parseInt($(input).val());
       if(!isNaN(num)){
           num = num-1;
           if(num > 0){
               $(input).val(num);
               showLoader(true);
               var line = $(this).parents(selectors.item).attr('data-ictcart-item');
               $.ajax({
                    type: "GET",
                    url: '/cart/change?line='+line+'&amp;quantity='+num,
                    cache: false,
                    success: function(data){
                        updateCart(false);
                    },
                    error: function(error){
                        console.log(error);
                        showError();
                    }
                });
           }
       }
   }

   function addQuantity(){
       var input = $(this).parents(selectors.item).find(selectors.quantity);
       var num = parseInt($(input).val());
       if(!isNaN(num)){
           num = num+1;
           if(num > 0){
               $(input).val(num);
               showLoader(true);
               var line = $(this).parents(selectors.item).attr('data-ictcart-item');
               $.ajax({
                    type: "GET",
                    url: '/cart/change?line='+line+'&amp;quantity='+num,
                    cache: false,
                    success: function(data){
                        updateCart(false);
                    },
                    error: function(error){
                        console.log(error);
                        showError();
                    }
                });
           }
       }
   }

   function showLoader(show){
       if($(selectors.loader).length){
        if(show)
             $(selectors.loader).css('display', 'flex');
         else
             $(selectors.loader).css('display', 'none');
       }
   }
}